import { MapPin, Star } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

function Card_vendeur({ vendeur, name }: any) {
    const {t} = useTranslation()
    const navigate = useNavigate()
    return (
        <div className=' w-[90%] md:w-[18%] p-3 py-5 shadow-[#00000040] flex flex-col shadow-sm rounded-sm'>
            <div className=' flex items-center justify-center'>
                <img className='w-[80px] h-[80px] rounded-full' src={vendeur.profile_image_url ? vendeur.profile_image_url : "/assets/Vector.png"} alt="imag" />
            </div>
            <div className='flex mt-2 flex-row items-center justify-between'>
                <p className='text-[13px] font-bold font-sans'>{vendeur.name}</p>
                <div className='flex flex-row text-[#005412] bg-[#DBFFE8] text-[8px] font-[400]'>
                    <Star color='#005412' size={10} />
                    {vendeur.average_note}
                </div>
            </div>
            <div className='flex flex-row items-center justify-start mt-3 text-[10px]'>
                <MapPin size={12}/>
                <div>
                    {vendeur.region} {vendeur.departement} {vendeur.city}
                </div>
            </div>
            <div>
                {vendeur.experience}
            </div>
            <button onClick={()=>navigate("/detail_producteur", {state:{...vendeur, acteur_name:name},})} className='bg-[#15803D] w-[100%] md:w-[60%] m-auto mt-5 py-2 rounded-3xl text-[11px] text-white'>
                {t("voir_profil")}
            </button>
        </div>
    )
}

export default Card_vendeur
